import React from 'react';
import {useHistory} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {useTranslation, Trans} from 'react-i18next';
import cn from 'classnames';
import useMixPanel from 'hooks/useMixPanel';
import {GUEST_APP_EVENTS_NAME} from 'utils/constants';
import {PATHS} from '../../../Routes';
import {useCompare} from 'utils/hooks';
import {useComputedReservationDetails} from '../../../context/computedReservationDetails';
import {setHousingId} from '../../../store/slices/guestParamsEventsSlice';
import styles from './Main.module.sass';
import image from 'assets/main-pic-1.jpg';
import background from 'assets/back-welcome-img.jpg';
import background2x from 'assets/back-welcome-img@2x.jpg';
import Button from 'components/acommon/Button';
import BookingStatus from 'components/acommon/BookingStatus';
import {PayNow} from 'components';

const Main = () => {
  const history = useHistory();
  const {t, i18n} = useTranslation();
  const {reservation, isLeaderGuest, hasBiomatch, hasScanDocument} =
    useComputedReservationDetails();
  const {IdGuestAppEvents} = useMixPanel();
  const dispatch = useDispatch();

  const getCheckInPath = () => {
    if (isLeaderGuest) {
      return {pathname: PATHS.confirmBooking};
    }
    if (hasBiomatch || hasScanDocument) {
      return {pathname: PATHS.verificationStart};
    }
    return {pathname: PATHS.formPersonalData};
  };

  const guestAppVisitedEvent = React.useCallback(() => {
    dispatch(setHousingId(reservation.housing.id));
    IdGuestAppEvents(GUEST_APP_EVENTS_NAME.visited, {reservationId: reservation?.id});
    if (!localStorage.getItem('empty-member-from-init')) {
      localStorage.setItem(
        'empty-member-from-init',
        reservation?.guest_group?.members?.length === 0,
      );
    }
      }, [
    dispatch,
    IdGuestAppEvents,
    reservation?.housing?.id,
    reservation?.id,
    reservation?.guest_group?.members,
  ]);

  const hasItemIdChanged = useCompare(reservation?.id);
  React.useEffect(() => {
    if (hasItemIdChanged) {
      guestAppVisitedEvent();
    }
  }, [guestAppVisitedEvent, hasItemIdChanged]);

  function goToChekin() {
    IdGuestAppEvents(GUEST_APP_EVENTS_NAME.checkIn);
    history.push(getCheckInPath());
  }
  return (
    <div className={cn('section', styles.section)}>
      <div className={styles.container}>
        <div className={styles.preview}>
          <img
            className={styles.previewImage}
            src={image}
            srcSet={`${background} 1x, ${background2x} 2x`}
            alt="Main"
          />
          <div className={styles.wrap}>
            <div className={cn(styles.welcome)}>
              <h1 className={cn(styles.title, styles[i18n.language])}>
                <Trans i18nKey="let_s_check_in">Let’s check-in!</Trans>
              </h1>
              <div className={cn(styles.subtitle)}>
                {t('and_avoid_the_tedious_waiting_time')}
              </div>
              {/*------------------- Future Feature ------------------*/}
              {/*<Button to="/?signup=true" className={styles.checkin}>*/}
              {/*  {t('check_in_now')}*/}
              {/*</Button>*/}
              {/*------------------- Future Feature ------------------*/}
              <Button className={styles.checkin} onClick={goToChekin}>
                {t('check_in_now')}
              </Button>
            </div>
            <div className={styles.booking}>
              <div className={styles.bookingHeader}>
                <div className={styles.bookingTitle}>{t('your_booking')}</div>
                <PayNow />
              </div>
              <BookingStatus />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export {Main};
